module.exports = __webpack_public_path__ + "static/media/stop.0f276612.png";